// extracted by mini-css-extract-plugin
export default {"dialogSpinner":"styles_dialogSpinner__aW21Z"};